import React from 'react';

const Supply = ({ serviceData }) => {
    return (
        <span>
            {
            serviceData.supply == 0 ?
                "مشتری"
            :
            serviceData.supply == 1 &&
                "انبار"
            }
        </span>
    );
}

export default Supply;
